module.exports = __webpack_public_path__ + "static/media/27OCHA14.d0e56b6a.jpg";